import { judgeNullQueryTypes } from '@ow/utils'

export const filterSpec = {
  queryTypes: ['judgeNull'].map((p) => judgeNullQueryTypes[p]),
}
